import PageContainer from '@/components/layout/page-container';
import AddEditProjectForm from '@/modules/projects/add-projects';

export default function AddProjectsPage() {
  return (
    <PageContainer>
      <div className='max-w-4xl rounded bg-white p-6'>
        <div className='space-y-6'>
          <AddEditProjectForm mode='add' />
        </div>
      </div>
    </PageContainer>
  );
}
